import { useEffect } from 'react';
import { useDocumentTitle } from '../../hooks/useDocumentTitle';
import { useScrollRestoration } from '../../hooks/useScrollRestoration';
import { Link, useParams } from 'react-router-dom';
import { useCollectionStore } from '../../store/collectionStore';
import { ProductCards } from '../ProductGrid/ProductGrid';
import './Collections.css';
import { collectionCopy } from './collectionCopy';
import Carousel from '../Carousel/Carousel';
import { useCarouselSlides } from '../../hooks/useCarouselSlides';
export default function CollectionPage() {
  const { slug = '' } = useParams();
  const slides = useCarouselSlides();
  const page = useCollectionStore((s) => s.pages[slug]);
  const fetchPage = useCollectionStore((s) => s.fetchPage);
  useEffect(() => {
    fetchPage(slug);
  }, [slug, fetchPage]);
  useScrollRestoration(`collection:${slug}`);
  useDocumentTitle(page?.data?.title ?? 'Collection');
  return (
    <section className="collection-page page-container">
      <nav className="collection-page__breadcrumb" aria-label="Breadcrumb">
        <Link to="/">Home</Link> / {page?.data?.title ?? 'Collection'}
      </nav>
      {page?.unavailable ? (
        <h1>Collection not found</h1>
      ) : (
        <>
          <h1>{page?.data?.title ?? 'Collection'}</h1>
          {page?.data && collectionCopy[slug] && (
            <p className="collection-page__intro">{collectionCopy[slug]}</p>
          )}
          {page?.data && (
            <>
              <Carousel key={slug} label={page.data.title} slides={slides[slug] ?? []} compact />
              <ProductCards items={page.data.items} />
              {!page.data.items.length && <p>No products available yet.</p>}
            </>
          )}
          <div className="collection-page__status" aria-live="polite">
            {page?.loading && <p role="status">Loading products…</p>}
            {page?.error && (
              <div role="alert">
                <p>{page.error}</p>
                <button onClick={() => fetchPage(slug, Boolean(page.data))}>Try again</button>
              </div>
            )}
            {page?.data?.has_more && !page.error && (
              <button disabled={page.loading} onClick={() => fetchPage(slug, true)}>
                Load more
              </button>
            )}
          </div>
        </>
      )}
    </section>
  );
}
